import { useEffect, useState } from "react";
import { useCurrentBlock } from "../store/hooks";
import Countdown from "react-countdown";

const CountdownTimer = ({ lastStakingBlock, blockTime = 3 }: any) => {
  const currentBlock = useCurrentBlock();
  const [timer, setTimer] = useState(Date.now());

  useEffect(() => {
    if (currentBlock && lastStakingBlock) {
      const lastBlockAsNumber = Number(lastStakingBlock);
      const blockDiff = lastBlockAsNumber - currentBlock;
      if (blockDiff <= 0) {
        setTimer(Date.now());
        return;
      }
      const newTimer = blockDiff * blockTime * 1000 + Date.now();
      setTimer(newTimer);
    }
  }, [currentBlock, lastStakingBlock, blockTime]);

  const renderCountdown = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: any) => {
    if (completed) return <p className="mb-0">Ended</p>;

    return (
      <p
        className="mb-0"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "2px",
        }}
      >
        {days !== 0 && <span className="time">{days}D:</span>}
        {hours !== 0 && <span className="time">{hours}H:</span>}
        {minutes !== 0 && <span className="time">{minutes}M:</span>}
        {seconds !== 0 && <span className="time">{seconds}S</span>}
      </p>
    );
  };

  return (
    <Countdown
      key={timer}
      zeroPadTime={2}
      date={timer}
      renderer={renderCountdown}
    />
  );
};

export default CountdownTimer;
